import type { ResolutionConfigMap } from '@frontend/api';
import {
  HStack,
  VStack,
  Text,
  OutlineCircleInfoIcon,
  Flex,
  Heading,
  ReqsReviewFeatureIcon,
  Avatar,
  Box,
  ChatIcon,
} from '@frontend/legacy-components';

import { ICON_STYLES } from '../utils/cascader';
import {
  getResolutionDisplayString,
  getResolutionIcon,
} from '../utils/resolutions';
import type { FormStateData } from './RulesDetailModal';

export const RulePreviewItem = ({
  rule,
  configMap,
}: {
  rule: FormStateData;
  configMap: ResolutionConfigMap;
}) => {
  return (
    <VStack
      border="1px solid"
      borderColor="separator.border"
      borderRadius="md"
      gap={1}
      padding={1}
      backgroundColor="page.surface"
      alignItems="stretch"
      className="rule-preview-item"
    >
      <HStack
        alignItems="stretch"
        flexGrow={1}
        justifyContent="space-between"
        className="rule-preview-header"
      >
        <HStack gap={1} className="rule-preview-title">
          <ReqsReviewFeatureIcon color="interaction.main" h={3} w={3} />
          <Heading color="feature.placeholder" size="md">
            {rule.name || 'Rule Name'}
          </Heading>
        </HStack>
        <HStack>
          <Avatar
            opacity={0.5}
            size="sm"
            boxShadow="0 0 0 2px var(--chakra-colors-page-surface)"
          />
          <OutlineCircleInfoIcon
            color="interaction.disabled"
            size={2.5}
            my={0.25}
            className="rule-preview-info-icon"
          />
        </HStack>
      </HStack>
      <HStack>
        <Box
          bg="page.plateMedium"
          height={2.5}
          width={3}
          borderRadius="sm"
          opacity={0.5}
        />
        <Box
          bg="page.plateMedium"
          height={2.5}
          width={11}
          borderRadius="full"
          opacity={0.5}
        />
        <Box
          bg="page.plateMedium"
          height={2.5}
          width={6}
          borderRadius="full"
          opacity={0.5}
        />
      </HStack>
      <VStack align="stretch" spacing={0} className="rule-preview-resolutions">
        {rule.resolutions?.map((resolution, index) => {
          const Icon = getResolutionIcon(resolution.type);
          const isFirst = index === 0;
          const isLast = index === (rule.resolutions?.length ?? 0) - 1;
          return (
            <Flex
              key={resolution.id}
              border="1px solid"
              borderColor="separator.border"
              borderTopRadius={isFirst ? 'md' : 0}
              borderBottomRadius={isLast ? 'md' : 0}
              marginLeft={4}
              alignItems="center"
              py={0.75}
              px={1.5}
              gap={1}
              mt={!isFirst ? '-1px' : 0}
              className="rule-preview-resolution-item"
            >
              {Icon && (
                <Icon
                  {...ICON_STYLES}
                  color="feature.placeholder"
                  className="rule-preview-resolution-icon"
                />
              )}
              <Text
                color="feature.placeholder"
                size="md"
                className="rule-preview-resolution-text"
              >
                {getResolutionDisplayString(
                  resolution,
                  configMap[resolution.type],
                )}
              </Text>
            </Flex>
          );
        })}
      </VStack>
      <HStack pl={4} gap={0.5}>
        <Text size="sm" color="feature.placeholder">
          Discuss this
        </Text>
        <ChatIcon color="feature.placeholder" />
      </HStack>
    </VStack>
  );
};
